const Status = [
    { label: '全部', value: "" },
    { label: '审核中', value: "审核中" },
    { label: '已驳回', value: "已驳回" },
    { label: '已完成', value: "已完成" },
    // { label: '付款中', value: "付款中" },
    { label: '已撤消', value: "已撤消" },
]

const CreditType = [
    { label: '保证金', value: "Deposit" },
    { label: '银行保函', value: "BankGuarantee" },
    { label: '公司保函', value: "CorpGuarantee" },
]

const PaymentWay = [
    { label: 'Annual', value: "AnnualAdditional" },
    { label: 'Lump Sum', value: "LumpSum" }
]

const PartnerType = [
    {
        label: "LSP",
        value: "LSP"
    },
    {
        label: "CSP",
        value: "CSP"
    }
]

const CreateOrderType = [
    {
        label: "追加订单",
        value: "AdditionalOrder"
    },
    {
        label: "初始订单",
        value: "InitialOrder"
    }
]

const ProductType = [
    { label: 'Azure', value: "Azure" },
    { label: 'O365', value: "O365" },
    { label: 'D365', value: "D365" }
]

const ContractType = [
    { label: 'Indirect', value: "Indirect" },
    { label: 'Direct', value: "Direct" }
]

const BillingTerm = [
    { label: '30天', value: "30Days" },
    { label: '45天', value: "45Days" },
    { label: '60天', value: "60Days" },
    { label: '90天', value: "90Days" },
]


export {
    Status,
    CreditType,
    PartnerType,
    PaymentWay,
    CreateOrderType,
    ProductType,
    ContractType,
    BillingTerm
}